import { Component } from '@theme/component';

/**
 * Shows/hides the subscription discount message block based on whether a selling
 * plan is active. Reads selling plan state from the parent variant-content element's
 * dataset, which is updated by variant-content.js on every variant/selling-plan change.
 *
 * Price overrides (compare_at strikethrough and one-time compare-at) are handled
 * entirely via CSS custom properties set from _subscription-discount-message.liquid —
 * no shadow DOM text mutation, which would corrupt ReCharge's cart payload.
 *
 * @extends {Component}
 */
class SubscriptionDiscountMessage extends Component {
  connectedCallback() {
    super.connectedCallback?.();
    this.#updateVisibility();
  }

  updatedCallback() {
    super.updatedCallback?.();
    this.#updateVisibility();
  }

  #updateVisibility() {
    const variantContent = /** @type {HTMLElement | null} */ (this.closest('variant-content'));
    const sellingPlanId = variantContent?.dataset.sellingPlanId;
    this.hidden = !sellingPlanId;
  }
}

if (!customElements.get('subscription-discount-message')) {
  customElements.define('subscription-discount-message', SubscriptionDiscountMessage);
}
